import React from 'react';
import { Card } from 'bumbag';
import _get from 'lodash/get';
import type { NavigateFunction } from 'react-router-dom';

import { withRouter } from '@medipass/react-core/router';
import sdk from '@medipass/web-sdk';

import Page from 'legacy/components/account/layout/Page';
import PaymentMethodForm from 'legacy/components/account/payment-methods/PaymentMethodForm';
import WithAuthentication from 'legacy/components/WithAuthentication';
type Props = {
  navigate: NavigateFunction;
};

class CreatePaymentMethod extends React.PureComponent<Props> {
  handleAddPaymentMethod = async ({ nonce, source }: { nonce: string; source: string }) => {
    const { navigate } = this.props;

    const accountId = _get(sdk, 'account._id');

    const paymentMethod = await sdk.payments.createAccountPaymentMethod(accountId, nonce, source);
    navigate('/account/payment-methods/');
    return paymentMethod;
  };
  render = () => (
    <WithAuthentication>
      <Page minWidthBreakpoint="mobile" title="Add a payment method">
        <Card>
          <PaymentMethodForm onSubmit={this.handleAddPaymentMethod} title="Add a payment method" />
        </Card>
      </Page>
    </WithAuthentication>
  );
}

export default withRouter(CreatePaymentMethod);
